<template>
  <div class="error-popup-container animated zoomIn">
    <div :class="['error-popup', err.type == 'err' ? 'err-pink' : 'err-orange']" v-for="err in fit20.errMsgs">
      <img :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="closeError(err.id)" />
      {{ err.msg }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'Error',
  props: ["fit20", "closeError"],
  data() {
    return {

    };
  },
  methods: {

  },
  created: async function () {

  }
};
</script>

<style>
.error-popup-container {
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 auto;
  z-index: 9999999999999999;
  border: none !important;
}

.error-popup {
  position: relative;
  width: 60%;
  color: white;
  margin-top: 20px;
  padding: 20px;
  border-radius: 10px;
}

.err-pink {
  background-color: #cb061d;
}

.err-orange {
  background-color: var(--fit20-orang);
}

.error-popup img {
  width: 15px;
  position: absolute;
  top: 10px;
  right: 10px;
}
</style>
